import DiscountState from '@/types/store/DiscountState';

const state: DiscountState = {
  discounts: {},
};

export default state;
